import { PayloadAction } from '@reduxjs/toolkit';

import { DataState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const setLoadingMoreReducer = (state: DataState, action: PayloadAction<boolean>) => {
  state.loadingMore = action.payload;
};

export default setLoadingMoreReducer;
